module.exports = __webpack_public_path__ + "img/logo-t.36c240ea.png";